import { Component, Inject } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { SystemActionService } from '../crud-service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { MediaObserver } from '@angular/flex-layout';
import { TypeIndexEnum } from 'src/app/domain/registration/enums/type-index.enum';
import { SystemActionCrudIndex } from './crud-index';
import { Router } from '@angular/router';

@Component({
  selector: 'app-product-category-select-index',
  templateUrl: './crud-index-select.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [SystemActionService],
})
export class SystemActionIndexSelectComponent extends SystemActionCrudIndex {
  override title: string = 'SELECIONE UM AÇÃO DO SISTEMA';
  constructor(
    override dialog: MatDialog,
    override service: SystemActionService,
    override toastService: ToastService,
    override mediaObserver: MediaObserver,
    public dialogRefSelect: MatDialogRef<SystemActionIndexSelectComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: {
      type: TypeIndexEnum;
      select: boolean;
      systemActionCategoryId: any;
    },
    override router: Router
  ) {
    super(dialog, service, toastService, mediaObserver, router);
    this.dataSelect = data;

    if (data.systemActionCategoryId)
      this.params.systemActionCategoryId = data.systemActionCategoryId;
  }

  ngOnInit(): void {}

  override filter(event: any) {
    event = { filter: event };
    this.params = { ...this.params, ...event };
    this.loadList();
  }

  onCancel() {
    this.dialogRefSelect.close();
  }

  onSelect(data: any) {
    this.dialogRefSelect.close(data?.row);
  }
}
